// @flow
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Chip from '@material-ui/core/Chip';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import ListItemText from '@material-ui/core/ListItemText';
import styled from 'styled-components';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import shortcutList from '../../../assets/shortcuts';

import Transition from '../../components/Transition';

const Shortcut = styled(Chip)`
  border-bottom: 3px;
  border-color: grey !important;
`;

type Props = {
  open: boolean,
  close: Function,
};

type State = {
  tab: number,
};

class ScribeShortcutModal extends React.Component<Props, State> {
  state: State;

  constructor(props: Props) {
    super(props);
    this.state = {
      tab: 0,
    };
    this.handleChangeTab = this.handleChangeTab.bind(this);
  }

  handleChangeTab = (event: Object, tab: number) => {
    this.setState({ tab });
  };

  render() {
    const { tab } = this.state;
    const { open, close } = this.props;

    return (
      <Dialog
        TransitionComponent={Transition}
        open={open}
        onClose={close}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Shortcut List</DialogTitle>
        <DialogContent>
          <Tabs
            value={tab}
            onChange={this.handleChangeTab}
            indicatorColor="primary"
            textColor="secondary"
            centered
          >
            <Tab label="Windows" />
            <Tab label="Mac" />
          </Tabs>
          {shortcutList &&
            shortcutList.map(categorie => (
              <div key={categorie.title}>
                <Typography
                  variant="subtitle1"
                  margin="normal"
                  gutterBottom
                  key={categorie.title}
                >
                  {categorie.title}
                </Typography>
                <List>
                  {categorie.content.map(shortcutL => (
                    <div key={shortcutL.title + Math.random()}>
                      <ListItem>
                        {tab === 0 &&
                          shortcutL.shortcut.windows.map((keycode, i, arr) => (
                            <span key={keycode.toString()}>
                              <Shortcut label={keycode} />
                              {i !== arr.length - 1 ? ' + ' : ' '}
                            </span>
                          ))}
                        {tab === 1 &&
                          shortcutL.shortcut.mac.map((keycode, i, arr) => (
                            <span key={keycode.toString()}>
                              <Shortcut label={keycode} />
                              {i !== arr.length - 1 ? ' + ' : ' '}
                            </span>
                          ))}
                        <ListItemText align="right" primary={shortcutL.title} />
                      </ListItem>
                    </div>
                  ))}
                </List>
              </div>
            ))}
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={close}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ScribeShortcutModal;
